/*  MUI  */
import {
    Alert,
    Button,
    Checkbox,
    FormControlLabel,
    Grid,
    Typography
} from '@mui/material';

/*  Shared  */
import { Permission } from 'application/Shared/Components/Core';
import { PermissionPicker } from 'application/Shared/Components/Pickers';
import { Notify, Response, Route } from 'application/Shared/Helpers';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

/*  React  */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { withRouter } from 'router/withRouter';

class UserSettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clientId: '',
            loaded: false,
            route: '',
            user: {}
        };
    }

    componentDidMount() {
        const { match, user } = this.props;
        const { clientId, partnerId } = match.params;
        const route = Route.buildBaseAdminRoute({ clientId, partnerId });
        this.setState({ clientId, loaded: true, route, user });
    }

    save = async () => {
        const { t } = this.props;
        const { user, clientId } = this.state;
        const { id, disabled } = user;

        const params = { disabled };
        if (clientId) {
            params.platformTenantId = clientId;
        }

        try {
            const response = await axios.put(`/user/${id}`, params);
            if (Response.hasData(response)) {
                Notify.s(t('UserAdminSettings.user_settings_saved'));
            }
        } catch (e) {
            debug.e('Unable to save User Settings', e);
            Notify.e(t('Common.error'));
        }
    };

    render() {
        const { t } = this.props;
        const { loaded, user, route } = this.state;

        if (!loaded) {
            return null;
        }

        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Alert severity="info" icon={false}>
                        {t('UserAdminSettings.description')}
                    </Alert>
                </Grid>
                <Grid item xs={12}>
                    <Typography
                        color="textSecondary"
                        variant="body2"
                        style={{ fontWeight: 600 }}
                    >
                        {t('UserAdminSettings.user_permissions')}
                    </Typography>
                    <PermissionPicker value={user.permissionId} visualOnly />
                    <Permission required="default_admin">
                        <br />
                        <Link
                            className="link underline"
                            to={`${route}/permissions/`}
                        >
                            {t('UserAdminSettings.view_permissions')}
                        </Link>
                    </Permission>
                </Grid>
                <Grid item xs={12}>
                    <Typography
                        color="textSecondary"
                        variant="body2"
                        style={{ fontWeight: 600 }}
                    >
                        {t('UserAdminSettings.user_management')}
                    </Typography>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={user.disabled}
                                color="primary"
                                onChange={() =>
                                    this.setState({
                                        user: {
                                            ...user,
                                            disabled: !user.disabled
                                        }
                                    })
                                }
                            />
                        }
                        label={
                            <>
                                {t('UserAdminSettings.user_disabled')}{' '}
                                {t('UserAdminSettings.user_disabled_subtext')}
                            </>
                        }
                    />
                </Grid>
                <Grid item xs={12}>
                    <Button
                        color="primary"
                        onClick={() => this.save()}
                        variant="contained"
                    >
                        {t('Common.save_settings')}
                    </Button>
                </Grid>
            </Grid>
        );
    }
}
export default withRouter(withTranslation()(UserSettings));
